var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowOutward = function SvgArrowOutward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "arrow_outward_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#arrow_outward_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 8.4-8.9 8.9a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275.95.95 0 0 1-.275-.7q0-.425.275-.7L14.6 7H7a.97.97 0 0 1-.713-.287A.97.97 0 0 1 6 6q0-.424.287-.713A.97.97 0 0 1 7 5h10q.424 0 .712.287Q18 5.576 18 6v10q0 .424-.288.712A.97.97 0 0 1 17 17a.97.97 0 0 1-.712-.288A.97.97 0 0 1 16 16z"
  }))));
};
export default SvgArrowOutward;